// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f719ce9","453":"75bbac9d","455":"278ab503","821":"49a00493","977":"464da16e"}[chunkId] + ".chunk.js";
};